module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "con01"
    }
  }, [_c('p', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cover")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/title01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Title Page")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ded_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ded01#ded01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#ch02"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03#ch03"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#ch04"
    }
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ch05#ch05"
    }
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "epilogue_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue01#epilogue01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "wine_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/wine01#wine01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Wildcat Wine")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "wine01_ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/wine01_ch01#wine01_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ack01#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "also_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/also01#also01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books by Claire Matturro")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "praise_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/praise01#praise01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AN OCEAN OF PRAISE FOR CLAIRE MATTURRO’S SKINNY-DIPPING")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "copy_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/copy01#copy01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0